import { booleanAttribute, Component, HostBinding, Input } from '@angular/core';

export type UiButtonVariant = 'primary' | 'outline' | 'neutral' | 'danger' | 'destructive' | 'link' | 'table';
export type UiButtonSize = 'sm' | 'md' | 'lg' | 'xl';

const VARIANT_CLASSES: Record<UiButtonVariant, string> = {
  primary: 'btn-primary',
  outline: 'btn-outline-primary',
  neutral: 'btn-outline-secondary',
  danger: 'btn-outline-danger',
  destructive: 'btn-danger',
  link: 'btn-link',
  table: 'ui-table',
};

/** Text button on top of the global .btn styles; see shared/ui/README.md. */
@Component({
  selector: 'button[uiButton], a[uiButton]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['./ui-button.component.scss'],
})
export class UiButtonComponent {
  /** empty attribute: primary */
  @Input() uiButton: UiButtonVariant | '' = 'primary';
  @Input() size: UiButtonSize = 'md';
  @Input({ transform: booleanAttribute }) block = false;

  @HostBinding('class')
  get classes(): string {
    return [
      'btn',
      VARIANT_CLASSES[this.uiButton || 'primary'],
      this.size === 'sm' ? 'btn-sm' : '',
      this.size === 'lg' ? 'ui-lg' : '',
      this.size === 'xl' ? 'ui-xl' : '',
      this.block ? 'ui-block' : '',
    ].filter(Boolean).join(' ');
  }
}
